const matchesColumn = (entry, columnKey) => (entry?.column || entry?.key) === columnKey;

export const resolveColumnFilter = (column, { filterItems = {}, searchKeys = [] } = {}) => {
    const sort = (filterItems.sort || []).find((entry) => matchesColumn(entry, column.key)) || null;
    const dropdowns = (filterItems.dropdown || []).filter((entry) => matchesColumn(entry, column.key));
    const dates = (filterItems.datepicker || []).filter((entry) => matchesColumn(entry, column.key));
    const dateRanges = (filterItems.daterangepicker || []).filter((entry) => matchesColumn(entry, column.key));
    const searchEntry = (searchKeys || []).find((entry) => matchesColumn(entry, column.key)) || null;

    const hasPopoverFilters = dropdowns.length > 0 || dates.length > 0 || dateRanges.length > 0;
    const hasAnyControl = !!sort || !!searchEntry || hasPopoverFilters;

    return { sort, dropdowns, dates, dateRanges, searchEntry, hasPopoverFilters, hasAnyControl };
};

export const unmatchedSearchKeys = (columns = [], searchKeys = []) => {
    const columnKeys = columns.map((column) => column.key);
    return (searchKeys || []).filter((entry) => !columnKeys.includes(entry.column || entry.key));
};
